import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SESSION_EXPIRED_TITLE_ID, SessionExpiredDialogComponent } from './session-expired-dialog.component';

/**
 * Asks the admin to sign in again once the API rejects their (expired) token. A burst of failing
 * requests opens a single dialog, and it can't be dismissed: nothing works until they re-login.
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiredDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly snackBar = inject(MatSnackBar);
  private openDialog: MatDialogRef<SessionExpiredDialogComponent> | null = null;

  open(): void {
    if (this.openDialog) {
      return;
    }

    // The generic "request failed" alert is noise next to this dialog.
    this.snackBar.dismiss();

    const dialogRef = this.dialog.open(SessionExpiredDialogComponent, {
      disableClose: true,
      role: 'alertdialog',
      ariaLabelledBy: SESSION_EXPIRED_TITLE_ID,
      width: 'min(400px, calc(100vw - 32px))',
    });
    this.openDialog = dialogRef;
    dialogRef.afterClosed().subscribe(() => {
      if (this.openDialog === dialogRef) {
        this.openDialog = null;
      }
    });
  }
}
